import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Storage } from '@ionic/storage-angular';
import { CoreProvider } from 'src/app/services/core';


export interface UserOptions {
  User: string,
  Password: string,
  saveoptions: boolean,
  autologin: boolean
}

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls: ['login.scss']
})
export class LoginPage {
  @ViewChild('loginForm', { static: false }) loginForm: NgForm;

  login: UserOptions = { User: '', Password: '', saveoptions: false, autologin: false };
  submitted = false;
  working = false;
  asmodal = false;
  noautologin = true;

  constructor(private core: CoreProvider, private storage: Storage) {
    // this.asmodal = navParams.get('asmodal');
    // this.noautologin = navParams.get('noautologin');

    if (this.core.isLoggedIn)
      this.core.nav.navc.navigateRoot('/');
    else {
      this.storage.get('loginuser').then((sLogin) => {
        if (sLogin) this.login = sLogin;
        if (this.noautologin) this.login.autologin = false;

        if (this.login.autologin) setTimeout(() => this.onLogin(this.loginForm), 1000);
      });
    }
  }

  onLogin(form: NgForm) {
    this.submitted = true;

    if (form.valid && !this.working) {
      this.working = true;
      this.storage.set('loginuser', (this.login.saveoptions) ? this.login : { User: '', Password: '', saveoptions: false, autologin: false });
      this.core.auth.login({
        user: this.login.User,
        password: this.login.Password,
      }, () => {
        this.core.nav.navc.navigateRoot('/');
        this.working = false;
      }, err => {
        this.working = false;
        console.error(err);
        this.core.errorToast(null, (err.status==401)?this.core.lpipe.transform('Invalid user or password'):null);
      });
    }
  }

  logout() {
    this.core.auth.logout();
  }

}
